import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

// NOTE: использовать для сборки Metadoor в ветке dev
import {AppModule} from './app/app.module';
// NOTE: использовать для сборки RSHB  ветке rshb_dev
// import { AppModule } from './app-rshb/app.module';
import {environment} from './environments/environment';
import * as moment from 'moment';
import {initializeYandexMetrika} from "./yandex-metrika";

if (environment.production) {
  enableProdMode();
}

if (environment.yandexMetrika.enabled && environment.yandexMetrika.counterId) {
  initializeYandexMetrika(environment.yandexMetrika.counterId);
  console.log('%cYandex Metrika initialized with ID: ' + environment.yandexMetrika.counterId, 'font-weight: bold; color: yellow;');
} else {
  console.log('%cYandex Metrika is not initialized', 'font-weight: bold; color: yellow;');
}

moment.updateLocale('ru', {week: {dow: 1}});

  function bootstrap() {
    const runAppModule = AppModule;
    platformBrowserDynamic()
      .bootstrapModule(runAppModule)
      .catch((err) => console.error(err));
  }

  if (document.readyState === 'complete') {
    bootstrap();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrap);
  }
